import React from 'react';
import { useNavigate } from 'react-router';
import TopicsNavigation from '../../components/TopicsNavigation';
import VideoPlayerFull from '../../components/VideoPlayerFull';
import Page from '../Page';
import { useState } from 'react';
import AfterVideo from '../../components/AfterVideo';
import PageIntro from '../PageIntro';

export default function ProjectManagement() {

  const [showNavigation, setShowNavigation] = useState(false);
  const [hideIntro, setHideIntro] = useState(false);

  return (
    <Page
      outroInstant={true}
      content={
        <>
          <div className={`video-intro ${hideIntro ? 'hide-intro' : ''}`}>
            <PageIntro content={
              <>
                <div className="topic-intro-title">
                  Project<br></br>Management
                </div>
              </>
            } />
          </div>
          <VideoPlayerFull
            url="https://vimeo.com/872586673"
            urlMobile="https://vimeo.com/877893711"
            onEnd={() => setShowNavigation(true)}
            onStart={() => {
              setTimeout(function() {
                setHideIntro(true);
              }, 100);
            }}
          />
          <AfterVideo
            text={
              <>
                Ensure timely<br></br>project delivery
              </>
            }
            isShowing={showNavigation}
          />
          <TopicsNavigation isShown={showNavigation} />
        </>
      }
    />
  );
}
